const EloCalculator = ({ isCorrect, userElo, questionElo }) => {
  const K = 30;

  // Hàm tính xác suất kỳ vọng
  const calculateExpected = (userRating, questionRating) => {
    const EA = 1 / (1 + Math.pow(10, (questionRating - userRating) / 400));
    const EB = 1 / (1 + Math.pow(10, (userRating - questionRating) / 400));
    return { EA, EB };
  };

  if (userElo === undefined || questionElo === undefined) {
    console.error("Missing userElo or questionElo");
    return userElo;
  }

  const { EA, EB } = calculateExpected(userElo, questionElo);
  const SA = isCorrect ? 1 : 0;
  // const SB = 1 - SA;

  const newElo = userElo + K * (SA - EA);

  return Math.max(1, newElo);
};

export default EloCalculator;
